import {
  getRouteExternalAssigneeType,
  useExternalAssignee,
} from "@web-app/components";

import { TableRow } from "../data";

export default function FulfillmentMethodCell({ data }: { data: TableRow }) {
  const { externalAssigneeType } = useExternalAssignee(data);

  if (data?.entity === "order") {
    // Orders in a route handed off to a provider are delivered by that provider
    const routeExternalAssigneeType = getRouteExternalAssigneeType(data.route);

    return routeExternalAssigneeType || externalAssigneeType
      ? "External DSP"
      : "Internal Fleet";
  }

  return null;
}
